import React, { useMemo } from 'react';
import { useProfilesTabNavigation } from '../../../utils/appNavigationNames';
import Stack from '../Stack';
import CardButton from '../CardButton';
import { getIntl } from '../../../utils/intl';
import useNotes, { NoteQueryArgs } from '../../../hooks/api/useNotes';
import { useProfileInAppNotifications } from '../../../hooks/api/useProfileInAppNotifications';
import { useProfileUnreadInAppNotificationCount } from '../../../hooks/api/useProfileInUnreadAppNotificationCount';

const intl = getIntl(
    'components.screens.tabs.profiles.profileActivityScreen.profileActivityScreenV2.mobileActivitySection',
    {
        messages: 'Messages',
        notes: 'Notes',
        cardSubtext: 'Total ({countText})',
    },
);

export type MobileActivitySectionOwnProps = {
    profileId: string;
};

export type MobileActivitySectionProps = MobileActivitySectionOwnProps;

const MobileActivitySection: React.FC<MobileActivitySectionProps> = (props) => {
    const { navigate } = useProfilesTabNavigation();
    const messagesRes = useProfileInAppNotifications({
        medicalProfileId: props.profileId,
    });
    const { unreadInAppNotificationCount } = useProfileUnreadInAppNotificationCount({
        medicalProfileId: props.profileId,
    });
    const noteQueryArgs: NoteQueryArgs = useMemo(
        () => ({
            medicalProfileId: props.profileId,
            entityType: 'medical-profile',
        }),
        [props.profileId],
    );

    const notesRes = useNotes({
        noteQueryArgs,
    });

    const getSubtext = (count: number, isLoading: boolean) => {
        return intl('cardSubtext', { countText: isLoading ? '...' : count });
    };

    return (
        <Stack
            horizontal
            space={10}
            style={{ flex: 1, alignSelf: 'stretch', marginTop: 20 }}
            justify="center"
            align="flex-start"
        >
            <CardButton
                onPress={() => navigate('messages', { profileId: props.profileId })}
                title={intl('messages')}
                icon="MessageSquare"
                subText={getSubtext(messagesRes.allNotifications.length, messagesRes.isLoadingNotifications)}
                cardStyle={{ width: 'auto' }}
                hoverContainerStyles={{ flex: 1 }}
                style={{ flex: 1 }}
                testID="card-button-messages"
                notificationCount={unreadInAppNotificationCount}
            />
            <CardButton
                onPress={() => navigate('profile-notes', { profileId: props.profileId })}
                title={intl('notes')}
                icon="Edit2"
                subText={getSubtext(notesRes.notes.notes.length, notesRes.isLoading)}
                cardStyle={{ width: 'auto' }}
                hoverContainerStyles={{ flex: 1 }}
                style={{ flex: 1 }}
                testID="card-button-notes"
            />
        </Stack>
    );
};

export default React.memo(MobileActivitySection);
